import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CredentialsService, UrlParamsService } from '@app/core';
import { AppService } from '@app/services';

@Component({
  selector: 'app-documents-home',
  templateUrl: './documents-home.component.html',
  styleUrls: ['./documents-home.component.scss'],
  standalone: false
})
export class DocumentsHomeComponent implements OnInit {
  constructor(public credentialsService: CredentialsService, public urlParamsService: UrlParamsService, private appService: AppService, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.appService.loadStatusPageWidget();
  }
}
